import { useEffect, useState, useRef } from 'react';
import {
  NavbarContainer,
  Logo,
  Menu,
  HamburgerIcon,
  ModalContent,
} from './Navbar.style';
import Original from '../../assets/images/Original.svg';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import LanguageSwitcher from '../Language/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t } = useTranslation('navBar');
  const [activeMenu, setActiveMenu] = useState('home');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const modalRef = useRef(null);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  useEffect(() => {
    // Atualiza o menu ativo baseado na URL
    const currentPage = location.pathname.replace('/', '') || 'home';
    setActiveMenu(currentPage);

    // Fecha o menu ao clicar fora
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalOpen(false);
      }
    };

    if (isModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [location.pathname, isModalOpen]);

  return (
    <NavbarContainer>
      <Link to={'/'}>
        <Logo>
          <img src={Original} alt="Logo" />
        </Logo>
      </Link>

      {/* Ícone do Hambúrguer (visível apenas no mobile/tablet) */}
      <HamburgerIcon onClick={toggleModal}>
        {isModalOpen ? <FaTimes /> : <FaBars />}
      </HamburgerIcon>

      {/* Menu padrão (visível apenas no desktop) */}
      <Menu className="desktop-menu">
        {[
          { to: '/', label: 'Home', key: 'home' },
          { to: '/audit', label: 'Audit', key: 'audit' },
          {
            to: '/segmentacoes',
            label: t('navBar.segmentation'),
            key: 'segmentacoes',
          },
          { to: '/brandSafety', label: 'Brand Safety', key: 'brandSafety' },
          {
            to: '/brandSuitability',
            label: 'Brand Suitability',
            key: 'brandSuitability',
          },
          { to: '/quemSomos', label: t('navBar.aboutUs'), key: 'quemSomos' },
          { to: '/contato', label: t('navBar.contact'), key: 'contact' },
        ].map(({ to, label, key }) => (
          <li key={key}>
            <Link
              to={to}
              className={activeMenu === key ? 'active' : ''}
              onClick={() => setActiveMenu(key)}
            >
              {label}
            </Link>
          </li>
        ))}
        {/* <li>
          <LanguageSwitcher />
        </li> */}
      </Menu>

      {/* Modal dropdown no mobile */}
      {isModalOpen && (
        <ModalContent ref={modalRef}>
          <Menu className="mobile-menu">
            {[
              { to: '/', label: 'Home', key: 'home' },
              { to: '/audit', label: 'Audit', key: 'audit' },
              {
                to: '/segmentacoes',
                label: t('navBar.segmentation'),
                key: 'segmentacoes',
              },
              { to: '/brandSafety', label: 'Brand Safety', key: 'brandSafety' },
              {
                to: '/brandSuitability',
                label: 'Brand Suitability',
                key: 'brandSuitability',
              },
              {
                to: '/quemSomos',
                label: t('navBar.aboutUs'),
                key: 'quemSomos',
              },
              { to: '/contato', label: t('navBar.contact'), key: 'contact' },
            ].map(({ to, label, key }) => (
              <li key={key}>
                <Link
                  to={to}
                  className={activeMenu === key ? 'active' : ''}
                  onClick={() => {
                    setActiveMenu(key);
                    setIsModalOpen(false);
                  }}
                >
                  {label}
                </Link>
              </li>
            ))}
            {/* <li>
              <LanguageSwitcher />
            </li> */}
          </Menu>
        </ModalContent>
      )}
    </NavbarContainer>
  );
};

export default Navbar;
